import Entity from "@mm/state/model/requestModels/Entity";

export default class WidgetEntity extends Entity {
  static make(pageId, type, label, sortOrder, isSmsRelated) {
    return {
      ...super.make(),
      pageId,
      type,
      label,
      sortOrder,
      isSmsRelated
    };
  }
}
